import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsHome = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
              <polygon points="3.6648754 11.5447204 6.0463392 22.9617387 9.9687508 22.9617387 9.9687508 15.6072174 14.0312492 15.6072174 14.0312492 22.9617387 17.9536608 22.9617387 20.3351246 11.5447204 12.0000007 5.7311455 3.6648754 11.5447204"/>
      <polygon points="11.9999993 1.0382613 1.0032396 8.8130413 2.4741428 10.9143331 11.9999993 4.190199 21.4558125 11.1244617 22.9967604 9.0231699 11.9999993 1.0382613"/>

      </g>
    </SvgIcon>
  );
});

export default AppIconsHome;
